module.exports = __webpack_public_path__ + "img/8.df3512b3.png";